// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_5j-0";
export var eligibilityCardNotEligible = "_5j-1";